import { Box, Button } from '@factorialco/deprecated-design-system'
import { useField } from 'formik'
import { UniversalExportsExporterFilter } from 'generated/resources/graphql'
import { keyBy } from 'lodash'

import { FieldArray } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { FormFilter } from '../../types'
import AddButton from '../AddButton'
import FilterSelector from './FilterSelector'

interface Props {
  exporterOptions: UniversalExportsExporterFilter[]
  overrideFilters?: Record<string, Array<number | string | boolean>>
}

const Filters = ({ exporterOptions, overrideFilters = {} }: Props) => {
  const [_, { value: filters }] = useField<FormFilter[]>('filters')

  const optionsByName = keyBy(exporterOptions, 'name')

  const editableFilters = filters.filter((filter) => !(filter.name in overrideFilters))

  const addableOptions = exporterOptions.filter(
    (option) => !filters.find((f) => f.name == option.name) && !(option.name in overrideFilters)
  )

  return (
    <Box flexDirection="column">
      <FieldArray
        name="filters"
        render={(arrayHelpers) => (
          <Box gap="s16">
            {editableFilters.length > 0 && (
              <Box gap="s12" flexDirection="column">
                {editableFilters.map((filter) => {
                  const exporterFilter = optionsByName[filter.name]
                  if (!exporterFilter) return

                  const originalIndex = filters.findIndex((f) => f.name === filter.name)

                  return (
                    <Box
                      flexDirection="row"
                      justifyContent={'spaceBetween'}
                      alignItems="flexEnd"
                      key={filter.name}
                      height="s64"
                      gap="s8"
                    >
                      <FilterSelector
                        {...exporterFilter}
                        key={filter.name}
                        name={`filters.${originalIndex}`}
                        options={exporterFilter.options ?? []}
                      />
                      <Box paddingY="s6" alignItems="center">
                        <Button
                          onClick={() => arrayHelpers.remove(originalIndex)}
                          type="secondary"
                          iconName="remove"
                          aria-label={`remove-${filter.name}-filter`}
                        />
                      </Box>
                    </Box>
                  )
                })}
              </Box>
            )}
            <AddButton
              icon="add"
              options={addableOptions}
              onAdd={(filter) => {
                arrayHelpers.push({ name: filter.name, values: [] })
              }}
            >
              {i18n.t('universal_exports.filter.add_filter')}
            </AddButton>
          </Box>
        )}
      />
    </Box>
  )
}
export default Filters
